import PriceLabel from 'UI/PriceLabel';
import { TermEnum } from 'UI/PriceLabel/PriceLabel';
import { SubscribeDtoTypeEnum } from 'api/generated';
import { ActivePlan, Plan } from 'components/Modals/ChooseProductModal/components/Products/types';
import { FC } from 'react';
import styled, { css } from 'styled-components';

interface PriceSectionProps {
  term: TermEnum;
  mainColor: string | undefined;
  subscribeType: SubscribeDtoTypeEnum;
  termsCount: number;
  planType: ActivePlan | undefined;
  isResponsive: boolean;
  goldCount?: number;
  countPlans?: number;
  isMaxHeight?: boolean | undefined;
  onChoosePlan: any;
  currentPrice: number;
  isCurrentSubscribe: boolean;
  currentPriceLifetime: number;
  currentPaymentPeriod: string | undefined;
  currentPriceAnnual: number;
  isGoldSubscribe: boolean;
  isSelect: boolean;
  plan: any;
}

export const PriceSection: FC<PriceSectionProps> = ({
  isResponsive,
  subscribeType,
  mainColor,
  termsCount,
  planType,
  goldCount,
  countPlans,
  isMaxHeight,
  onChoosePlan,
  currentPrice,
  isCurrentSubscribe,
  currentPriceLifetime,
  currentPaymentPeriod,
  currentPriceAnnual,
  isSelect,
  plan,
}) => {
  const calculateCurrentPrice = (
    amount: number,
    defaultCouponDiscount?: number,
    defaultCouponDiscountType?: string,
  ) => {
    if (defaultCouponDiscount && amount - defaultCouponDiscount >= 1 && defaultCouponDiscountType === 'amount') {
      return amount - defaultCouponDiscount;
    }

    if (defaultCouponDiscount && defaultCouponDiscountType === 'percentage') {
      const discountAmount = amount * (defaultCouponDiscount / 100);

      if (currentPrice - discountAmount >= 1) {
        return amount - discountAmount;
      }
    }

    return amount;
  };

  return (
    <>
      {plan.priceMonthly && (
        <>
          <PriceWrapper isResponsive={isResponsive}>
            {isCurrentSubscribe && currentPaymentPeriod === TermEnum.MONTHLY && <YourPlan>Your plan</YourPlan>}
            <PriceContainer
              termCount={termsCount}
              mainColor={mainColor}
              activePlan={planType}
              subscribeType={subscribeType}
              term={TermEnum.MONTHLY}
              isSelect={isSelect}
              isResponsive={isResponsive}
              onClick={() => onChoosePlan(plan.priceMonthly, TermEnum.MONTHLY, subscribeType)}>
              <StyledPriceLabel
                termCount={termsCount}
                countPlans={countPlans}
                isMaxHeight={isMaxHeight}
                currentPrice={calculateCurrentPrice(
                  currentPrice || 0,
                  plan.priceMonthly?.defaultCoupon?.discountAmount,
                  plan.priceMonthly?.defaultCoupon?.discountType,
                )}
                oldPrice={plan.priceMonthly?.defaultCoupon?.discountAmount ? currentPrice || 0 : undefined}
                term={TermEnum.MONTHLY}
              />
            </PriceContainer>
          </PriceWrapper>
        </>
      )}
      {plan.priceAnnual && (
        <PriceWrapper isResponsive={isResponsive}>
          {isCurrentSubscribe && currentPaymentPeriod === TermEnum.YEARLY && <YourPlan>Your plan</YourPlan>}
          <PriceContainer
            termCount={termsCount}
            mainColor={mainColor}
            activePlan={planType}
            subscribeType={subscribeType}
            term={TermEnum.YEARLY}
            isResponsive={isResponsive}
            onClick={() => onChoosePlan(plan.priceAnnual, TermEnum.YEARLY, subscribeType)}>
            <StyledPriceLabel
              termCount={termsCount}
              isMaxHeight={isMaxHeight}
              goldCount={goldCount}
              currentPrice={calculateCurrentPrice(
                currentPriceAnnual || 0,
                plan.priceAnnual?.defaultCoupon?.discountAmount,
                plan.priceAnnual?.defaultCoupon?.discountType,
              )}
              oldPrice={plan.priceAnnual?.defaultCoupon?.discountAmount ? currentPriceAnnual || 0 : undefined}
              term={TermEnum.YEARLY}
            />
          </PriceContainer>
        </PriceWrapper>
      )}
      {plan.purchasePrice && (
        <PriceWrapper isResponsive={isResponsive}>
          {isCurrentSubscribe && currentPaymentPeriod === 'Purchase' && <YourPlan>Your plan</YourPlan>}
          <PriceContainer
            termCount={termsCount}
            mainColor={mainColor}
            activePlan={planType}
            subscribeType={subscribeType}
            term={TermEnum.LIFE_TIME}
            isResponsive={isResponsive}
            onClick={() => onChoosePlan(plan.purchasePrice as Plan, TermEnum.LIFE_TIME, subscribeType)}>
            <StyledPriceLabel
              isMaxHeight={isMaxHeight}
              termCount={termsCount}
              goldCount={goldCount}
              countPlans={countPlans}
              currentPrice={calculateCurrentPrice(
                currentPriceLifetime || 0,
                //@ts-ignore
                plan.purchasePrice?.defaultCoupon?.discountAmount,
                //@ts-ignore
                plan.purchasePrice?.defaultCoupon?.discountType,
              )}
              //@ts-ignore
              oldPrice={plan.purchasePrice?.defaultCoupon?.discountAmount ? currentPriceLifetime || 0 : undefined}
              term={TermEnum.LIFE_TIME}
            />
          </PriceContainer>
        </PriceWrapper>
      )}
      {plan.installmentPrice && (
        <PriceWrapper isResponsive={isResponsive}>
          {isCurrentSubscribe && currentPaymentPeriod === 'installment' && <YourPlan>Your plan</YourPlan>}
          <PriceContainer
            termCount={termsCount}
            mainColor={mainColor}
            activePlan={planType}
            subscribeType={subscribeType}
            term={'installment' as any}
            isResponsive={isResponsive}
            onClick={() => onChoosePlan(plan.installmentPrice as Plan, 'installment' as any, subscribeType)}>
            <StyledPriceLabel
              isMaxHeight={isMaxHeight}
              termCount={termsCount}
              goldCount={goldCount}
              countPlans={countPlans}
              currentPrice={calculateCurrentPrice(
                plan.installmentPrice?.amount || 0,
                //@ts-ignore
                plan.installmentPrice?.defaultCoupon?.discountAmount,
                //@ts-ignore
                plan.installmentPrice?.defaultCoupon?.discountType,
              )}
              //@ts-ignore
              oldPrice={
                plan.installmentPrice?.defaultCoupon?.discountAmount ? plan.installmentPrice?.amount || 0 : undefined
              }
              term={'installment' as any}
            />
          </PriceContainer>
        </PriceWrapper>
      )}
      {!plan.installmentPrice &&
        (subscribeType === SubscribeDtoTypeEnum.Silver || subscribeType === SubscribeDtoTypeEnum.Bronze) && (
          <PriceWrapper isResponsive={isResponsive}>
            <PriceContainer
              termCount={termsCount}
              mainColor={mainColor}
              activePlan={planType}
              subscribeType={subscribeType}
              term={'installment' as any}
              isSelect={false}
              isResponsive={isResponsive}
              onClick={() => {}}>
              <DisabledPriceLabel
                isMaxHeight={isMaxHeight}
                termCount={termsCount}
                goldCount={goldCount}
                countPlans={countPlans}>
                N/A
              </DisabledPriceLabel>
            </PriceContainer>
          </PriceWrapper>
        )}
    </>
  );
};

const PriceWrapper = styled.div<{ isResponsive: boolean }>`
  position: relative;
  width: ${({ isResponsive }) => (isResponsive ? '100%' : 'unset')};
`;

const PriceContainer = styled.div<{
  termCount: number;
  activePlan: { planType?: string; term: string } | undefined;
  subscribeType: string;
  term: string;
  isSelect?: boolean;
  isResponsive: boolean;
  mainColor: string | undefined;
}>`
  padding: 8px 8px;
  background: ${({ theme: { colors } }) => colors.neutrals[9]};
  border: ${({ subscribeType, activePlan, mainColor, isSelect, term, theme: { colors } }) => {
    // For Silver and Bronze N/A boxes, use background color for seamless appearance
    if (subscribeType === 'silver' || subscribeType === 'bronze') {
      return `2px solid ${colors.neutrals[9]}`;
    }
    return (activePlan && subscribeType === activePlan.planType && term === activePlan.term) || isSelect
      ? `2px solid ${mainColor}`
      : `2px solid ${colors.neutrals[9]}`;
  }};
  border-radius: 12px;
  align-items: center;
  margin: 12px 0px;
  display: ${({ isResponsive }) => (isResponsive ? 'flex' : 'block')};
  justify-content: ${({ isResponsive }) => (isResponsive ? 'center' : 'unset')};

  @media (max-width: 550px) {
    padding: ${({ termCount }) => {
      return termCount !== 1 ? '12px 8px' : '8px 8px';
    }};
  }
`;

const StyledPriceLabel = styled(PriceLabel)<{
  isMaxHeight: boolean | undefined;
  goldCount?: number;
  countPlans?: number;
}>`
  ${({ theme: { colors, typography } }) => css`
    gap: 8px;

    color: ${colors.neutrals[1]};
    ${typography.headline_semibold_18};
  `}

  display: ${({ isMaxHeight, goldCount }) => (isMaxHeight && goldCount === 1 ? 'flex' : 'flex')};
  flex-direction: ${({ isMaxHeight, goldCount }) => (isMaxHeight && goldCount === 1 ? 'column' : 'unset')};

  @media (max-width: 560px) {
    ${({ theme: { typography } }) => css`
      ${typography.body_large_bold_16}
      font-weight: 600;
      line-height: 14px;
    `}
  }
`;

const DisabledPriceLabel = styled.div<{
  isMaxHeight: boolean | undefined;
  goldCount?: number;
  countPlans?: number;
  termCount: number;
}>`
  ${({ theme: { colors, typography } }) => css`
    gap: 8px;
    color: ${colors.neutrals[1]};
    ${typography.headline_semibold_18};
  `}

  display: ${({ isMaxHeight, goldCount }) => (isMaxHeight && goldCount === 1 ? 'flex' : 'flex')};
  flex-direction: ${({ isMaxHeight, goldCount }) => (isMaxHeight && goldCount === 1 ? 'column' : 'unset')};
  align-items: center;
  justify-content: center;

  @media (max-width: 560px) {
    ${({ theme: { typography } }) => css`
      ${typography.body_large_bold_16}
      font-weight: 600;
      line-height: 14px;
    `}
    min-height: 48px;
  }
`;

const YourPlan = styled.p`
  ${({ theme: { typography } }) => typography.footnote_semibold_12}
  background: ${({ theme: { colors } }) => colors.primary[1]};
  padding: 4px 8px;
  border-radius: 12px;
  width: 82px;
  color: ${({ theme: { colors } }) => colors.neutrals[11]};
  position: absolute;
  text-align: center;
  top: -15px;
  right: 5px;
`;
